// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"132":"6231c279","343":"4cbdb72a","677":"7b7a1b72","733":"2413b8c2","920":"dfd984c1","938":"ffdfa51f"}[chunkId] + ".chunk.css";
};